import Shimmer from "components/ui/shimmer"

const ShipInfoLoading = () => (
  <div className="flex flex-col items-center" style={{ minHeight: "38px" }}>
    <Shimmer className="mb-8" style={{ height: "22px", width: "50%" }} />
    <Shimmer className="mb-4" style={{ height: "16px", width: "50%" }} />
    <Shimmer style={{ height: "16px", width: "60%" }} />
    {sl.config.enable_gift_preview_video && (
      <Shimmer className="mt-24" style={{ height: "16px", width: "50%" }} />
    )}
  </div>
)

export default ShipInfoLoading
